/* eslint-disable no-unused-vars */

import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Link, Redirect, useLocation, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as serviceWorker from './serviceWorker';
import { createBrowserHistory } from "history";

import Footer from './Components/Footer';
import Header from './Components/Header';
import App from './App';
import Stories from './Stories';
import StoryDetails from './StoryDetails';
import Challenge from './Challenge';
import CustomLayout from './CustomLayout';
import Preview from './Preview';
import ScrollToTop from './Components/ScrollToTop';
import pageError from './404';

window.$apiUrl = process.env.REACT_APP_API_URL;

class Index extends React.Component {
  constructor(props) {
    super();
    this.state = {

    };

  }

  render() {
    const history = createBrowserHistory();
    return (
      <Router basename={'/yep'} history={history}>
        <ScrollToTop />
        <div className="main_content">
          <div className="Public">
            <Header />
            <Switch>
              <Route exact path="/" component={App} />
              <Route path="/stories/:Title?" component={Stories} />
              <Route path="/StoryDetails/:id" component={StoryDetails} />
              <Route path="/customlayout" component={CustomLayout} />
              <Route path="/preview" component={Preview} />
              <Route path="/challenge" component={Challenge} />
              <Route path="*" exact={true} component={pageError} />
            </Switch>

            <Footer />
          </div>
        </div>
      </Router>
      // <React.StrictMode>

      // </React.StrictMode>,

    );
  }
}
ReactDOM.render(
  <Index />,
  document.getElementById('root')
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
